import { onReady } from "./runtime/on-ready.js";
import initAgents from "./lib/agents.js";
import initAnimations from "./lib/animations.js";
import initHeaderScrollOffset from "./lib/header-scroll-offset.js";
import initSmoothScroll from "./lib/smooth-scroll.js";

onReady(() => {
  initAgents();
  initAnimations();
  initHeaderScrollOffset();
  initSmoothScroll();
});
